import bgImage from '../../assets/moneybank.png' 

export default function Influencers(){
    return(
        <section
        id='about'
        className="about-section pt-120 pb-120 bg_img"
        data-background={bgImage}
      >
        <div className="container">
          <div className="row p-5">
          <div className="col-md-6 ">
              <div style={{textAlign:'left'}} className="about-content">
                <h2 className="section-title mb-3">
                  <span className="font-weight-normal">Referral programme for</span>{" "}
                  <b className="base--color">influencers</b>
                </h2>
         
                <p>
                minimum followers should be 5k + 
                </p>
              
                <p className="mt-4">
                25 usd worth of glsc for every share on Twitter , Facebook, Instagram, telegram and discord 
                </p>
                <p className="mt-4">
                Also chance to earn normal referral programme by getting link 
                </p>
                
              </div>
              {/* about-content end */}
            </div>
         <div className='col-md-6'>
            <img style={{marginLeft:'20%', marginRight:'25%' , marginTop:'5px'}} width={'70%'} src='https://bafybeicbvz6p3bnhzljrh7agytnwcs5kmsx72hak3z56sdg6dz4dg75274.ipfs.w3s.link/pngegg.png' alt='..' />
            
            {/* <iframe src="https://app.vectary.com/p/1e8UtgqYjeQ1Yhd02sQR6N" frameborder="0" width="100%" height="480"></iframe> */}
            </div>
         {/* offset-lg-6 */}
           
          </div>
        </div>
      </section>      
    );
}